(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumeriia-reviews"] && !Shopify.designMode) return;
  try {
    
function initializeLumeriiaReviews(root=document){root.querySelectorAll('.lumeriia-reviews').forEach(section=>{if(section.dataset.initialized)return;const track=section.querySelector('.lumeriia-reviews__track');if(!track)return;section.dataset.initialized='true';const previous=section.querySelector('.lumeriia-reviews__previous');const next=section.querySelector('.lumeriia-reviews__next');const update=()=>{previous.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};const move=direction=>{const card=track.querySelector('.lumeriia-review');track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update()})}initializeLumeriiaReviews();document.addEventListener('shopify:section:load',event=>initializeLumeriiaReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
